import { useEffect, useRef } from 'react';

const useParallax = (speed = 0.5) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementOffsetTop = element.offsetTop;
      
      // Calculate parallax based on scroll position
      // As user scrolls down, background moves up (creating depth effect)
      const parallaxOffset = (scrollTop - elementOffsetTop) * speed;
      
      // Apply the parallax effect
      element.style.setProperty('--parallax-offset', `${parallaxOffset}px`);
    };

    // Initial call
    handleScroll();

    // Throttle scroll events for better performance
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [speed]);

  return elementRef;
};

export default useParallax;

